export default {
  clearAllButtonStyles: {
    minWidth: '100px',
    height: '40px',
    textTransform: 'none',
    fontWeight: 600,
  },
};
